import { useEffect, useRef, useState } from "react";
/*

Renders screenshares, webcams and other raw inputs into a secret video object
this way it can be used to draw to a canvas

*/

const VideoProcess = ({ mediaStream, mediaStreams }) => {
  const [numVideo, setNumVideo] = useState(-1);
  const localVideo = useRef(null);

  useEffect(() => {
    if (!localVideo.current) {
      return;
    }

    // Check if we have more/less video tracks
    let eligibleTracks = 0;
    // lookup source track
    for (const srcStream of mediaStreams) {
      const thisTracks = srcStream.mediaSourceRef?.current?.getTracks() || [];
      for (const srcTrack of thisTracks) {
        if (srcTrack.kind == "video") {
          eligibleTracks++;
        }
      }
    }
    if (eligibleTracks == numVideo) {
      return;
    } else {
      console.log("amount of total video tracks changed to " + eligibleTracks);
    }

    if (
      mediaStream.mediaSourceRef &&
      mediaStream.mediaSourceRef.current
    ) {
      // Go go gadget autoplay
      var onVideoLoaded = () => {
        localVideo.current.play();
      };
      localVideo.current.autoplay = true;
      localVideo.current.addEventListener("loadeddata", onVideoLoaded);
      // Finally load the video track to prerender
      localVideo.current.srcObject = mediaStream.mediaSourceRef.current;
      console.log(
        "rendering raw input for ",
        mediaStream.mediaSourceRef.current.getTracks()
      );
    }
    setNumVideo(eligibleTracks);
    return;
  }, [
    mediaStream.mediaSourceRef,
    mediaStreams.length,
    localVideo.current,
  ]);

  return (
    <video
      control="false"
      playsInline
      autoPlay={true}
      muted="muted"
      ref={localVideo}
      height={mediaStream.properties.height}
      width={mediaStream.properties.width}
      hidden
    />
  );
};

export default VideoProcess;
